import { createAsyncThunk } from "@reduxjs/toolkit";
import { AppInfoActions } from "./AppInfoSlice";
import { AppInfoStateType, WebInfoStateType } from "src/shared/types/src";

export const updateAppInfo = createAsyncThunk(
    "setAppInfo", async ({ payload }: { payload: AppInfoStateType | WebInfoStateType }, { dispatch }) => {
        // const payload: AppInfoStateType = {
        //     appBuildNo: getBuildNumber(),
        //     appVersion: getReadableVersion(),
        //     bundleId: getBundleId(),
        //     osVersion: getSystemVersion(),
        //     platform: Platform.OS,
        //     brand: getBrand(),
        //     manufacturer: await getManufacturer(),
        //     deviceName: await getDeviceName()
        // }
        // dispatch(AppInfoActions.setAppInfo(payload));
        await dispatch(AppInfoActions.setAppInfo(payload));
    }
);